import FuelExpensesCreate from '../components/views/fuelExpenses/fuelExpensesCreate.vue'
import FuelExpenses from '../components/views/fuelExpenses/fuelExpenses.vue'

const routes = [
    {
        path: 'fuelExpenses',
        component: FuelExpenses,
        name: 'fuelExpenses',
        meta: {
            description: 'List of Fuel Expenses',
            title: 'Fuel Expenses',
            requiresAuth: true
        }
    },
    {
        path: 'fuelExpenses/fuelExpensesCreate/:_id',
        component: FuelExpensesCreate,
        name: 'fuelExpensesCreate',
        meta: {
            title: 'Add / Update Fuel Expenses',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/fuelexpenses.route.js